module.exports = __webpack_public_path__ + "img/LOGO3@2x.8c990c1a.png";